import React from 'react';

import styled from 'styled-components';

import visa from 'assets/images/icons/visa.png';

const VisaIcon = (props) => <Icon src={visa} {...props} />;

const Icon = styled.img`
	height: 25px;
	width: 50px;
	margin-left: 8px;
	margin-right: 8px;
`;

export default VisaIcon;
